import React, { useState } from 'react'

import { Box, Button, TablePagination, useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import PerfectScrollbar from 'react-perfect-scrollbar'

import { Card, MenuButton } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import { useSnackbar } from 'hooks'

import * as service from 'service'
import helpers from 'helpers'

const ManageCompaniesTable = ({
  show,
  ssoCorporateGroupCompanies,
  totalCount,
  handleChangePage,
  handleChangeRowsPerPage,
  page,
  perPage,
  refresh,
}) => {
  const [loading, setLoading] = useState(false)

  const snackbar = useSnackbar()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const handleDestroy = async (ssoCorporateGroupCompany) => {
    try {
      setLoading(true)
      await service.dponet.ssoCorporateGroupCompanies.destroy({
        ssoCorporateGroupId: ssoCorporateGroupCompany?.ssoCorporateGroup?.id,
        ssoCorporateGroupCompanyId: ssoCorporateGroupCompany?.id,
      })
      refresh()
      snackbar.open({
        message: 'Empresa desvinculada com sucesso!',
        variant: 'success',
      })
    } catch (error) {
      return snackbar.open({
        message: helpers.formatters.errorMessage(
          error?.response?.data?.error || 'Erro ao desvincular empresa!',
        ),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box mt={2} mb={2}>
      <Card title="Empresas vinculadas">
        <PerfectScrollbar
          options={{ wheelPropagation: false, useBothWheelAxes: true }}
        >
          <Table emptyMessage="Nenhuma empresa foi encontrada.">
            <TableHead>
              <TableRow>
                <TableCell width="10%">ID </TableCell>
                <TableCell width="40%">Nome</TableCell>
                <TableCell width="40%">Documento</TableCell>
                {!show && (
                  <TableCell width="10%" align="center">
                    Desvincular
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {ssoCorporateGroupCompanies?.map((ssoCorporateGroupCompany) => (
                <TableRow key={ssoCorporateGroupCompany?.company?.id}>
                  <TableCell>{ssoCorporateGroupCompany?.company?.id}</TableCell>
                  <TableCell>
                    {ssoCorporateGroupCompany?.company?.name}
                  </TableCell>
                  <TableCell>
                    {ssoCorporateGroupCompany?.company?.document}
                  </TableCell>
                  {!show && (
                    <TableCell align="center" disableTooltip>
                      <MenuButton>
                        <Button
                          disabled={loading}
                          onClick={() =>
                            handleDestroy(ssoCorporateGroupCompany)
                          }
                        >
                          Desvincular
                        </Button>
                      </MenuButton>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Box px={2} display="flex" justifyContent="flex-end">
            <TablePagination
              component="div"
              count={totalCount || 0}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              page={page - 1}
              rowsPerPage={perPage}
              rowsPerPageOptions={[5, 10, 25, 100]}
              labelRowsPerPage={isDesktop ? 'Por página' : ''}
              nextIconButtonProps={{ size: 'small' }}
              backIconButtonProps={{ size: 'small' }}
            />
          </Box>
        </PerfectScrollbar>
      </Card>
    </Box>
  )
}

export default ManageCompaniesTable
